import 'bootstrap/dist/css/bootstrap.min.css';
import type { JSX } from 'react';

import AuthController from './auth/AuthController';
import { BrandProvider } from './context/BrandProvider';
import './theme/styles.scss';

export default function App(): JSX.Element {
  return (
    <BrandProvider>
      <AuthController />
    </BrandProvider>
  );
}
